import { render, staticRenderFns } from "./OperationSubsidyActiveScore.vue?vue&type=template&id=00a6a752&scoped=true"
import script from "./OperationSubsidyActiveScore.vue?vue&type=script&lang=js"
export * from "./OperationSubsidyActiveScore.vue?vue&type=script&lang=js"
import style0 from "./OperationSubsidyActiveScore.vue?vue&type=style&index=0&id=00a6a752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a6a752",
  null
  
)

export default component.exports